import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Problem from './components/Problem';
import TreatmentSelector from './components/TreatmentSelector';
import Services from './components/Services';
import Proof from './components/Proof';
import Footer from './components/Footer';

const App: React.FC = () => {
  return (
    <div className="min-h-screen bg-neutral-950 text-white selection:bg-white selection:text-black">
      <Navbar />
      <main>
        <Hero />
        <Problem />
        <TreatmentSelector />
        <Services />
        <Proof />
      </main>
      <Footer />
    </div>
  );
};

export default App;